import * as React from 'react';
import { AccountLink } from '@/lib/navigation/links/AccountLink';
import xMark from '../../../../assets/images/static_pages/x_mark.svg';
import { OnboardingInfoContext } from './onboarding-info';

export const BackToSetup = () => {
  const [showComp, setShowComp] = React.useState(true);
  const backToSetupClassName = `avo-ui-3 top-right ${showComp ? '' : 'hide'}`;
  const handleClick = () => setShowComp(false);
  const { onboarding } = React.useContext(OnboardingInfoContext);

  if (onboarding.length < 1) return null;
  return (
    <div
      id="back-to-setup"
      className={backToSetupClassName}
    >
      <div
        role="button"
        tabIndex={0}
        onKeyPress={handleClick}
        className="close-btn"
        onClick={handleClick}
      >
        <img src={xMark} alt="x-mark" />
      </div>
      <p className="white">
        Go back to Setup Page
      </p>
      <AccountLink path="onboarding">
        <span className="button lime">
          Go back to setup page
        </span>
      </AccountLink>
    </div>
  );
};
